const swsConfig = document.head.querySelector('[name~=sws_config][content]');
const jsonString = swsConfig ? atob(swsConfig.getAttribute('content')) : JSON.stringify({});
const {
    env,
    google_analytics_mount_event_name,
    profile_loaded_event_name,
    sessions_service,
    showRecentsEnabled,
    allowPolyFill,
    onetrustCookiesExist,
    onetrustToken,
    rejectOneTrustForScan,
    webservices_root,
    notificationsServiceRootUrl,
    notificationsEnabled,
    federated_search_config,
    assets_root,
    external_resource_integrity,
    google_tag_gateway_enabled
} = JSON.parse(jsonString);

const config = {
    env,
    assets_root,
    sessions_service,
    webservices_root,
    notificationsServiceRootUrl,
    notificationsEnabled,
    allowPolyFill: allowPolyFill || document.cookie.includes('allow-polyfills'),
    // ↓ depreciated
    onetrustCookiesExist: onetrustCookiesExist || (document.cookie.includes('OptanonConsent') && document.cookie.includes('OptanonAlertBoxClosed')),
    onetrustToken: onetrustToken,
    rejectOneTrustForScan: rejectOneTrustForScan || false,
    profileLoadedEventName: profile_loaded_event_name || 'sws_profile_loaded',
    // google analytics
    googleAnalytics: {
        hasMountedEventName: google_analytics_mount_event_name || 'sws_google_analytics_has_mounted',
        tagGatewayEnabled: google_tag_gateway_enabled ?? false,
        javascriptFile: '',
        /*env === 'production'
                ? 'https://www.google-analytics.com/analytics.js'
                : 'https://www.google-analytics.com/analytics_debug.js',*/
    },
    externalResourceIntegrity: external_resource_integrity ?? { scripts: {}, stylesheets: {} },

    // templating
    footer: {},
    header: {
        showRecentsEnabled: showRecentsEnabled || false,
        federatedSearchConfig: federated_search_config || {},
    },
};

export default config;
